<template>
  <div class="paymentFields">
    <div class="paymentOptions d-flex justify-content-around mt-3">
      <div
        v-for="(paymentMode, index) in filteredPaymentModes"
        :key="index"
        @click="selectPaymentMode(paymentMode)"
        :class="[
          'elementsradioButtonField',
          { elementsradioButtonFieldSelected: isPaymentModeSelected(paymentMode) }
        ]"
      >
        <div class="paymentLabel">
          <i
            v-if="paymentMode.icon"
            :class="['mr-2', paymentMode.icon]"
            style="font-size: 1.3rem;"
          ></i>
          {{ paymentMode.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentSelector",

  props: {
    defaultPaymentMode: {
      type: Number,
      default: 1,
    },
    isOnlinePaymentEnabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selectedPaymentMode: this.defaultPaymentMode,
      paymentModes: [
        { id: 0, label: "Paiement à la livraison", icon: "fas fa-money-bill-wave" },
        { id: 1, label: "Paiement en ligne", icon: "fas fa-credit-card" },
      ],
    };
  },

  computed: {
    filteredPaymentModes() {
      return this.isOnlinePaymentEnabled
        ? this.paymentModes
        : this.paymentModes.filter((mode) => mode.id !== 1);
    },
  },

  mounted() {
    if (!this.isOnlinePaymentEnabled && this.selectedPaymentMode === 1) {
      this.selectedPaymentMode = 0;
    }
    this.$emit("paymentMode", this.selectedPaymentMode);
  },

  methods: {
    selectPaymentMode(mode) {
      this.selectedPaymentMode = mode.id;
      this.$emit("paymentMode", mode.id);
    },
    isPaymentModeSelected(mode) {
      return this.selectedPaymentMode === mode.id;
    },
  },
};
</script>

<style scoped>
.paymentFields {
  margin-top: 1rem;
}

.paymentOptions {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.elementsradioButtonField {
  cursor: pointer;
  border: 2px solid #ccc;
  border-radius: 6px;
  padding: 12px 20px;
  transition: all 0.3s ease;
  text-align: center;
  min-width: 160px;
  background-color: #f9f9f9;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.elementsradioButtonField:hover {
  border-color: #999;
}

.elementsradioButtonFieldSelected {
  text-transform: uppercase;
  border-color: #2E469D;
  background: linear-gradient(135deg, #2E469D, #061b64);
  color: white;
  font-weight: bold;
  box-shadow: 0 4px 10px rgba(18, 18, 18, 0.3);
}

.paymentLabel {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
</style>
